import { translate, WebcastHelper, WebcastStatus } from "@kaltura/mediaspace-shared-utils";
import { KmsTypeSchedulingTimeInterval } from "@kaltura/mediaspace-shared-types";
import { SchedulingContainer, SchedulingLine } from "./styled-components";
import { StatusLive } from "@kaltura/mediaspace-shared-ui";
import { useEventListTimeFormatting } from "../useEventListTimeFormatting";

export interface EventListItemSchedulingProps {
    className?: string;
    schedulingData: KmsTypeSchedulingTimeInterval;
    showDate?: boolean;
    vertical?: boolean;
}

/**
 * Session card scheduling + live status.
 */
export const EventListItemScheduling = ({
    className = "",
    schedulingData,
    showDate = true,
    vertical,
}: EventListItemSchedulingProps) => {
    const { formattedTime, formattedDate } = useEventListTimeFormatting(schedulingData);

    const status = WebcastHelper.getLiveStatus(schedulingData);

    return (
        <SchedulingContainer
            vertical={vertical}
            className={`${className} kms-ds-event-list-item-date chromatic-ignore`}
        >
            <SchedulingLine
                variant={"body2Highlight"}
                content={"time"}
                vertical={vertical}
                className={"kms-ds-event-list-item-date-time"}
            >
                {formattedTime}
            </SchedulingLine>
            {showDate && (
                <SchedulingLine
                    variant={"body2Highlight"}
                    content={"date"}
                    vertical={vertical}
                    className={"kms-ds-event-list-item-date-date"}
                >
                    {formattedDate}
                </SchedulingLine>
            )}
            {status === WebcastStatus.live && (
                <StatusLive className={"kms-ds-event-list-item-status"}>{translate("Live")}</StatusLive>
            )}
        </SchedulingContainer>
    );
};
